import { Button } from 'blaze-ui/Button'
import { TLImageShape, TLUnknownShape } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { ArrowRefresh2 } from 'blaze-ui/icons'
import { useReplaceImage } from './useReplaceImage'
import { MaskShape } from 'components/VisualStudioPlayground/Shapes/MaskShape/Types'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { MobileButton } from 'components/MobileButton/MobileButton'

interface ContainerProps {
  selectedShape: TLImageShape | TLUnknownShape
}
interface Props {
  selectedShape: MaskShape | ImageShape
}

const ReplaceButton = ({ selectedShape }: Props) => {
  const editor = useEditor()
  const { replace } = useReplaceImage({ editor, selectedShape })
  const { isMobile } = useResponsiveDesign()

  if (isMobile) {
    return (
      <MobileButton variant="secondary" onPress={replace} icon={ArrowRefresh2}>
        Replace
      </MobileButton>
    )
  }
  return (
    <Button variant="secondary" onPress={replace} frontIcon={ArrowRefresh2}>
      Replace
    </Button>
  )
}

const ReplaceButtonContainer = ({ selectedShape }: ContainerProps) => {
  if (!['mask', 'image'].includes(selectedShape.type)) return null

  const shape = selectedShape?.type === 'mask' ? (selectedShape as MaskShape) : (selectedShape as ImageShape)
  return <ReplaceButton selectedShape={shape} />
}

export { ReplaceButtonContainer as ReplaceButton }
